import { render } from "./OnboardingChoice.vue?vue&type=template&id=f5afa44c&scoped=true"
import script from "./OnboardingChoice.vue?vue&type=script&lang=js"
export * from "./OnboardingChoice.vue?vue&type=script&lang=js"

import "./OnboardingChoice.vue?vue&type=style&index=0&id=f5afa44c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5afa44c"]])

export default __exports__